/* cspell:disable-next-line */
export * from './useComponentBreakpointsDepricated';
